<template>
  <ais-pagination>
    <div
      slot-scope="{
        currentRefinement,
        nbPages,
        pages,
        isFirstPage,
        isLastPage,
        refine,
        createURL
      }"
      class="text-center"
    >
      <span v-if="!isFirstPage" class="px-1">
        <a
          :href="createURL(currentRefinement - 1)"
          @click.prevent="refine(currentRefinement - 1)"
        >
          ‹
        </a>
      </span>

      <span
        v-for="page in pages"
        :key="page"
        :class="[
          'px-1',
          page === currentRefinement && 'text-smurfs-gold font-bold',
        ]"
      >
        <a
          :href="createURL(page)"
          :style="{ fontWeight: page === currentRefinement ? 'bold' : '' }"
          @click.prevent="refine(page)"
        >
          {{ page + 1 }}
        </a>
      </span>

      <span v-if="!isLastPage" class="px-1">
        <a
          :href="createURL(currentRefinement + 1)"
          @click.prevent="refine(currentRefinement + 1)"
        >
          ›
        </a>
      </span>
    </div>
  </ais-pagination>
</template>

<script>
export default {
  //
};
</script>

<style scoped>
</style>
